
























import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class FooterNav extends Vue {
	public async logout() {
		this.$auth.logout({ makeRequest: true });
		setTimeout(() => {
			this.$router.push({ name: 'auth.login' });
		}, 1000);
	}
}
